import { useEffect, useRef } from 'react';
import { Copy, Trash2 } from 'lucide-react';

interface ContextMenuProps {
  x: number;
  y: number;
  messageId: string;
  onClose: () => void;
  onCopy: (messageId: string) => void;
  onDelete: (messageId: string) => void;
}

export default function ContextMenu({
  x,
  y,
  messageId,
  onClose,
  onCopy,
  onDelete,
}: ContextMenuProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="fixed bg-bg-elevated border border-border-subtle rounded-lg shadow-xl py-1 min-w-[140px] z-[9999] backdrop-blur-lg animate-fade-in"
      style={{ left: x, top: y }}
    >
      <button
        onClick={() => {
          onCopy(messageId);
          onClose();
        }}
        className="w-full px-3 py-2 text-[13px] text-text-secondary hover:bg-bg-tertiary hover:text-text-primary flex items-center gap-2 transition-all rounded-sm"
      >
        <Copy size={14} />
        Copiar
      </button>
      <button
        onClick={() => {
          onDelete(messageId);
          onClose();
        }}
        className="w-full px-3 py-2 text-[13px] text-accent-red hover:bg-accent-red/10 flex items-center gap-2 transition-all rounded-sm"
      >
        <Trash2 size={14} />
        Eliminar
      </button>
    </div>
  );
}
